/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./combo-partial-ratio";
import * as i2 from "ionic-angular/navigation/nav-controller";
import * as i3 from "ionic-angular/navigation/nav-params";
var styles_ComboPartialRatioPage = [];
var RenderType_ComboPartialRatioPage = i0.ɵcrt({ encapsulation: 2, styles: styles_ComboPartialRatioPage, data: {} });
export { RenderType_ComboPartialRatioPage as RenderType_ComboPartialRatioPage };
export function View_ComboPartialRatioPage_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 0, "div", [], [[8, "className", 0]], null, null, null, null))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = i0.ɵinlineInterpolate(1, "circle ", _co.color, ""); _ck(_v, 0, 0, currVal_0); }); }
export function View_ComboPartialRatioPage_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "page-combo-partial-ratio", [], null, null, null, View_ComboPartialRatioPage_0, RenderType_ComboPartialRatioPage)), i0.ɵdid(1, 49152, null, 0, i1.ComboPartialRatioPage, [i2.NavController, i3.NavParams], null, null)], null, null); }
var ComboPartialRatioPageNgFactory = i0.ɵccf("page-combo-partial-ratio", i1.ComboPartialRatioPage, View_ComboPartialRatioPage_Host_0, { color: "color" }, {}, []);
export { ComboPartialRatioPageNgFactory as ComboPartialRatioPageNgFactory };
//# sourceMappingURL=combo-partial-ratio.ngfactory.js.map


//////////////////
// WEBPACK FOOTER
// ./src/pages/combo/combo-list/combo-partial-ratio/combo-partial-ratio.ngfactory.js
// module id = null
// module chunks = 